export const CAP = 3;

// FIN_META: per-financier contact email + extra required doc names, keyed by
// the real financier_list's financial_code (BDO, BPI, ...) — no config API
// returns an email field yet, so this stays hardcoded until a real endpoint
// is provided. Any financier whose code isn't listed here just gets no extra
// docs and no email shown (callers already guard with `|| {}`).
export const FIN_META = {
  BPI: { email: "homeloans@bpi.com.ph", extra: ["BPI Auto-Debit Enrollment Form"] },
  BDO: { email: "homeloans@bdo.com.ph", extra: [] },
  EW: { email: "mortgage@eastwestbanker.com", extra: ["Data Privacy Consent Form"] },
  CBC: { email: "homeloan@chinabank.ph", extra: [] },
  UB: { email: "mortgage@unionbankph.com", extra: [] },
  PNB: { email: "homeloan@pnb.com.ph", extra: [] },
  RCBC: { email: "housingloans@rcbc.com", extra: [] },
  SB: { email: "homeloans@securitybank.com.ph", extra: [] },
  ASL: { email: "credit@asialinkfinance.com.ph", extra: ["Post-Dated Cheques Undertaking"] },
  SAL: { email: "loans@southasialink.com.ph", extra: [] },
  TRB: { email: "loans@trbank.com.ph", extra: ["Board Resolution / Sec. Certificate", "TRBank KYC Form"] },
  GDF: { email: "loans@globaldominion.com.ph", extra: [] },
};

export const STEP_LABELS = ["Lead\ndetails", "Financier/Bank\nSelection", "Upload\nDocuments", "Loan\ndetails", "Customer\ndetails"];

export const POST_STAGE_DEFS = [
  { key: "send", label: "Send to\nBank" },
  { key: "noa", label: "NOA\nApproval" },
  { key: "contract", label: "Contract\nSigning" },
];
